import angular from 'angular';
import moment from "moment";

class ModalCreateUpdatePdpReCtrl {
    /*@ngInject*/
    constructor(logger) {
        this.logger = logger;

        this.TIME_MASK = {h: 0, m: 0, s: 0, ms: 0};
        this.DATE_FORMAT_MASK = 'YYYY-MM-DD';
        this.LOG_START_PDP = 'La date de début doit être supérieure ou égale à la date du jour'
        this.LOG_END_PDP = 'La date de fin doit être supérieure ou égale à la date de début et à la date du jour'
    }

    $onInit() {
        this.todayDate = moment(this.TIME_MASK).format(this.DATE_FORMAT_MASK);
        this.pdpStartDate = null;
        this.pdpEndDate = null;
    }

    confirm() {
        let vm = this;
        this.setDatesBeforSave()
        if (this.form.$valid) {
            this.prepareDatesBeforSave()
            vm.modalInstance.close({pdpStartDate: this.pdpStartDate, pdpEndDate: this.pdpEndDate});
        } else if (this.pdpStartDate.isBefore(this.todayDate)) {
            this.logger.error(this.LOG_START_PDP)

        } else if (this.pdpEndDate && this.pdpEndDate.isBefore(this.pdpStartDate) && !this.pdpEndDate.isSame(this.pdpStartDate)) {
            this.logger.error(this.LOG_END_PDP)
        }
    }

    maxStart() {
        if (this.pdpEndDate) {
            return moment(this.pdpEndDate)
        }
    }

    minStart() {
        return this.todayDate
    }

    minEnd() {
        if (this.pdpStartDate) {
            return moment(this.pdpStartDate)
        } else {
            return this.todayDate
        }
    }

    /** transforme une chaine de carac en une date
     *
     * @param dateString
     */
    formatDate(dateString) {
        if (dateString instanceof Date) {
            return moment(dateString);
        } else if (dateString) {
            const dateArray = dateString.replace(/-/g, '/').split('/');
            let formatedDate = new Date(dateArray[2], dateArray[1] - 1, dateArray[0]);
            return moment(formatedDate)
        }
    }

    setDatesBeforSave() {
        this.pdpStartDate = this.formatDate(this.form.pdpStartDate.$viewValue)
        this.pdpEndDate = this.pdpEndDate ? this.formatDate(this.form.pdpEndDate.$viewValue) : null;
    }

    prepareDatesBeforSave() {
        this.pdpStartDate = this.formatDate(this.form.pdpStartDate.$viewValue).format(this.DATE_FORMAT_MASK)
        this.pdpEndDate = this.pdpEndDate ? this.formatDate(this.form.pdpEndDate.$viewValue).format(this.DATE_FORMAT_MASK) : null;
    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }
}

angular.module('app.principal').component('modalCreateUpdatePdpRe', {
    templateUrl: require('./modal-platform-partner-history.html'),
    controller: ModalCreateUpdatePdpReCtrl,
    bindings: {
        resolve: '<',
        modalInstance: '<',
    },
});
